module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"work_count":"Work count","all":"All languages","lang_filter":"Language filter"},"cs":{"work_count":"Počet děl","all":"Všechny jazyky","lang_filter":"Filtr podle jazyka"}}')
  delete Component.options._Ctor
}
